// src/utils/prakritiQuestionsData.js
// Updated according to the official Prakriti Parikshan Updated form (20 questions).

export const prakritiQuestionsData = [
  {
    id: 1,
    titleMr: "१. तुमच्या शरीराची एकूण बांधणी कशी आहे?",
    titleEn: "1. Overall Body Frame / Build",
    options: {
      A: { mr: "बारीक, उंच/हडकुळा, सांधे स्पष्ट दिसणारे", en: "Thin, tall/lean, prominent joints", dosha: "Vata" },
      B: { mr: "मध्यम बांधा, प्रमाणात वजन, विकसित स्नायू", en: "Medium build, proportionate weight, well-developed muscles", dosha: "Pitta" },
      C: { mr: "रुंद, जड बांधा, दणकट शरीर", en: "Broad, heavy build, sturdy body", dosha: "Kapha" }
    }
  },
  {
    id: 2,
    titleMr: "२. तुमचे वजन कसे बदलते?",
    titleEn: "2. Weight Tendencies",
    options: {
      A: { mr: "वजन वाढणे कठीण, पटकन कमी होते", en: "Hard to gain weight, loses weight easily", dosha: "Vata" },
      B: { mr: "प्रयत्नानुसार वजन सहज वाढते किंवा कमी होते", en: "Gains/loses weight easily with effort", dosha: "Pitta" },
      C: { mr: "वजन खूप सहज वाढते, कमी करणे अत्यंत कठीण जाते", en: "Gains weight very easily, hard to lose", dosha: "Kapha" }
    }
  },
  {
    id: 3,
    titleMr: "३. तुमच्या सांध्यांचे स्वरूप कसे आहे?",
    titleEn: "3. Joint Characteristics",
    options: {
      A: { mr: "स्पष्ट दिसणारे, हालचाल करताना कट-कट आवाज करणारे", en: "Prominent, cracking sound on movement", dosha: "Vata" },
      B: { mr: "लवचिक, मध्यम आकाराचे, उबदार", en: "Flexible, medium-sized, warm", dosha: "Pitta" },
      C: { mr: "दणकट, चरबी/मांसाने झाकलेले, न दिसणारे सांधे", en: "Sturdy, well-padded, non-prominent joints", dosha: "Kapha" }
    }
  },
  {
    id: 4,
    titleMr: "४. तुमचे खांदे आणि छातीची रुंदी कशी आहे?",
    titleEn: "4. Shoulder & Chest Width",
    options: {
      A: { mr: "अरुंद छाती आणि खांदे", en: "Narrow chest & shoulders", dosha: "Vata" },
      B: { mr: "मध्यम, सामान्य स्नायूंची वाढ", en: "Medium, normal muscle growth", dosha: "Pitta" },
      C: { mr: "रुंद, रुबाबदार आणि दणकट छाती", en: "Broad, impressive, sturdy chest", dosha: "Kapha" }
    }
  },
  {
    id: 5,
    titleMr: "५. तुमच्या त्वचेचा पोत कसा आहे?",
    titleEn: "5. Skin Texture",
    options: {
      A: { mr: "कोरडी, रुक्ष, पातळ, भेगा पडणारी", en: "Dry, rough, thin, cracking", dosha: "Vata" },
      B: { mr: "उबदार, मऊ, संवेदनशील, लालसरपणा/तीळ असणारी", en: "Warm, soft, sensitive, moles/redness", dosha: "Pitta" },
      C: { mr: "गुळगुळीत, ओलसर, जाड, थंड, तेलकट", en: "Smooth, moist, thick, cold, oily", dosha: "Kapha" }
    }
  },
  {
    id: 6,
    titleMr: "६. तुमचा त्वचेचा रंग (वर्ण) कसा आहे?",
    titleEn: "6. Complexion / Skin Color",
    options: {
      A: { mr: "निस्तेज, काळा/सावळा किंवा पिवळसर छटा असणारा", en: "Dull, dark/dusky or yellowish tinge", dosha: "Vata" },
      B: { mr: "गोरा, लालसर, गुलाबी किंवा तांबूस छटा असणारा", en: "Fair, reddish, pinkish or coppery tone", dosha: "Pitta" },
      C: { mr: "चमकदार, स्वच्छ, गोरा किंवा गडद सावळा", en: "Glowing, clear, fair or deep dusky", dosha: "Kapha" }
    }
  },
  {
    id: 7,
    titleMr: "७. डोयाच्या केसांचे स्वरूप कसे आहे?",
    titleEn: "7. Hair Quality",
    options: {
      A: { mr: "कोरडे, रुक्ष, विरळ, कुरळे", en: "Dry, rough, sparse, curly", dosha: "Vata" },
      B: { mr: "मऊ, बारीक, तांबूस/पटपट पांढरे होणारे", en: "Soft, fine, reddish/early graying", dosha: "Pitta" },
      C: { mr: "दाट, काळे, कुरळे/लांब, चमकदार", en: "Thick, black, long/wavy, lustrous", dosha: "Kapha" }
    }
  },
  {
    id: 8,
    titleMr: "८. तुमचे डोळे कसे आहेत?",
    titleEn: "8. Eyes",
    options: {
      A: { mr: "लहान, कोरडे, निस्तेज, वारंवार पापण्या मिटणारे", en: "Small, dry, dull, frequent blinking", dosha: "Vata" },
      B: { mr: "मध्यम, तीक्ष्ण, प्रकाशाचा त्रास होणारे, कडा लाल असणारे", en: "Medium, sharp, light-sensitive, reddish rims", dosha: "Pitta" },
      C: { mr: "मोठे, आकर्षक, पांढरेशुभ्र, लांब पापण्या असणारे", en: "Large, attractive, pearly white, long eyelashes", dosha: "Kapha" }
    }
  },
  {
    id: 9,
    titleMr: "९. नखांचे स्वरूप कसे आहे?",
    titleEn: "9. Nail Characteristics",
    options: {
      A: { mr: "लहान, कोरडी, ठिसूळ, रुक्ष, काळसर", en: "Small, dry, brittle, rough, darkish", dosha: "Vata" },
      B: { mr: "मऊ, गुलाबी, गुळगुळीत, लवचिक", en: "Soft, pinkish, smooth, flexible", dosha: "Pitta" },
      C: { mr: "रुंद, मजबूत, जाड, चमकदार, पांढरट", en: "Broad, strong, thick, shiny, whitish", dosha: "Kapha" }
    }
  },
  {
    id: 10,
    titleMr: "१०. दात आणि हिरड्या कशा आहेत?",
    titleEn: "10. Teeth & Gums",
    options: {
      A: { mr: "असमान, लहान, कोरडे, किडणारे", en: "Uneven, small, dry, prone to cavities", dosha: "Vata" },
      B: { mr: "मध्यम, पिवळसर छटा, हिरड्यांतून सहज रक्त येणारे", en: "Medium, yellowish, bleeding gums", dosha: "Pitta" },
      C: { mr: "मोठे, पांढरे, मजबूत, एका ओळीत असणारे", en: "Large, white, strong, well-aligned", dosha: "Kapha" }
    }
  },
  {
    id: 11,
    titleMr: "११. तुमची भूक (अग्नि) कशी आहे?",
    titleEn: "11. Appetite / Agni",
    options: {
      A: { mr: "विषम — कधी खूप लागते, तर कधी अजिबात लागत नाही", en: "Irregular (Vishamagni) - highly fluctuating", dosha: "Vata" },
      B: { mr: "तीक्ष्ण — वेळेवर जेवण न मिळाल्यास सहन होत नाही", en: "Intense (Tikshnagni) - cannot skip meals", dosha: "Pitta" },
      C: { mr: "मंद — कमी भूक लागते, जेवण न पचल्यास त्रास होत नाही", en: "Mild/Low (Mandagni) - low appetite", dosha: "Kapha" }
    }
  },
  {
    id: 12,
    titleMr: "१२. तुमचे पोट साफ होण्याचे स्वरूप (कोष्ठ) कसे आहे?",
    titleEn: "12. Bowel Movements / Koshta",
    options: {
      A: { mr: "कडक, कोरडा मल, गॅस आणि बद्धकोष्ठतेचा त्रास", en: "Hard, dry stool, gas, constipation", dosha: "Vata" },
      B: { mr: "पातळ, मऊ मल, दिवसातून अनेकदा शौचास व्हावे लागणे", en: "Loose, soft stool, multiple times daily", dosha: "Pitta" },
      C: { mr: "नियमित, व्यवस्थित, रोज एकाच वेळी पोट साफ होणे", en: "Regular, well-formed, once daily", dosha: "Kapha" }
    }
  },
  {
    id: 13,
    titleMr: "१३. पचनाशी संबंधित कोणता त्रास वारंवार होतो?",
    titleEn: "13. Digestive Complaints",
    options: {
      A: { mr: "गॅस, पोट फुगणे, पोटात कळा येणे", en: "Gas, bloating, abdominal pain/cramps", dosha: "Vata" },
      B: { mr: "पित्त होणे, जळजळ, छातीत जळजळ, अति तहान लागणे", en: "Acidity, heartburn, excessive thirst", dosha: "Pitta" },
      C: { mr: "जेवणानंतर सुस्तपणा, पचन मंद होणे, कफ होणे", en: "Post-meal heaviness, sluggish digestion, phlegm", dosha: "Kapha" }
    }
  },
  {
    id: 14,
    titleMr: "१४. घाम येण्याचे प्रमाण (स्वेद) कसे आहे?",
    titleEn: "14. Perspiration / Sweating",
    options: {
      A: { mr: "खूप कमी, दुर्गंधी नसलेला", en: "Scanty, odorless", dosha: "Vata" },
      B: { mr: "खूप जास्त, उग्रवास असणारा, गरम घाम", en: "Profuse, pungent odor, hot sweat", dosha: "Pitta" },
      C: { mr: "मध्यम, स्थिर, दुर्गंधी नसलेला", en: "Moderate, steady, odorless", dosha: "Kapha" }
    }
  },
  {
    id: 15,
    titleMr: "१५. हवामानातील बदलांना तुम्ही कसा प्रतिसाद देता?",
    titleEn: "15. Weather Sensitivity",
    options: {
      A: { mr: "थंडी आणि वारा सहन होत नाही; उबदार हवामान आवडते", en: "Cold & wind uncomfortable; prefers warmth", dosha: "Vata" },
      B: { mr: "उकाडा आणि ऊन सहन होत नाही; थंड हवामान आवडते", en: "Heat & sun uncomfortable; prefers cool", dosha: "Pitta" },
      C: { mr: "थंड आणि दमट हवामान आवडत नाही, पण सहन होते", en: "Dislikes cold & humid, but tolerates easily", dosha: "Kapha" }
    }
  },
  {
    id: 16,
    titleMr: "१६. तुमची झोप (निद्रा) कशी आहे?",
    titleEn: "16. Sleep Quality / Pattern",
    options: {
      A: { mr: "हलकी, मध्येच मोडणारी, निद्रानाशाचा त्रास", en: "Light, interrupted, insomnia prone", dosha: "Vata" },
      B: { mr: "मध्यम झोप, उष्णता असल्यास सहज जागी होणारी", en: "Moderate sleep, easily wakes if warm", dosha: "Pitta" },
      C: { mr: "गाढ, शांत, दीर्घ झोप, सकाळी लवकर जाग न येणे", en: "Deep, long sound sleep, hard to wake early", dosha: "Kapha" }
    }
  },
  {
    id: 17,
    titleMr: "१७. तुमची शारीरिक ताकद (बल) आणि सहनशक्ती कशी आहे?",
    titleEn: "17. Physical Strength & Stamina",
    options: {
      A: { mr: "कमी ताकद, थोडे काम केले तरी थकवा येतो", en: "Low strength, fatigues quickly", dosha: "Vata" },
      B: { mr: "मध्यम ताकद, मानसिक इच्छाशक्ती दांडगी असते", en: "Medium strength, high mental drive/willpower", dosha: "Pitta" },
      C: { mr: "उत्तम ताकद, भरपूर शारीरिक श्रम करण्याची क्षमता", en: "Excellent strength & high physical stamina", dosha: "Kapha" }
    }
  },
  {
    id: 18,
    titleMr: "१८. तुमची बोलण्याची पद्धत (वाक्) कशी आहे?",
    titleEn: "18. Speech Style",
    options: {
      A: { mr: "जलद, सतत बोलणारा, उच्च आवाजात बोलणारा", en: "Fast, talks non-stop, loud", dosha: "Vata" },
      B: { mr: "स्पष्ट, मुद्देसूद, प्रभावी, तीक्ष्ण आवाजात बोलणारा", en: "Clear, precise, articulate, sharp", dosha: "Pitta" },
      C: { mr: "हळूवार, गंभीर, मधुर आणि मऊ आवाजात बोलणारा", en: "Slow, deep, melodious, gentle", dosha: "Kapha" }
    }
  },
  {
    id: 19,
    titleMr: "१९. ताणतणाव असताना तुमची मुख्य भावना कोणती असते?",
    titleEn: "19. Emotional Reaction to Stress",
    options: {
      A: { mr: "भीती, चिंता, घाबरणे, अस्वस्थता", en: "Fear, anxiety, nervousness, worry", dosha: "Vata" },
      B: { mr: "राग, चिडचिड, असहनशीलता, संताप", en: "Anger, irritability, intolerance", dosha: "Pitta" },
      C: { mr: "शांतता, आळस, दुर्लक्ष करणे, लोभ", en: "Calmness, lethargy, indifference", dosha: "Kapha" }
    }
  },
  {
    id: 20,
    titleMr: "२०. तुमचा सामाजिक स्वभाव कसा आहे?",
    titleEn: "20. Social Temperament",
    options: {
      A: { mr: "खूप सक्रिय, फिरायला आवडणारे, एका जागी न बसणारे", en: "Highly active, loves wandering/change, restless", dosha: "Vata" },
      B: { mr: "ध्येयवादी, स्पर्धात्मक, नेतृत्व करणारे", en: "Ambitious, competitive, leader", dosha: "Pitta" },
      C: { mr: "शांत, स्थिर, निष्ठेचे, दीर्घकाळ टिकणारे संबंध ठेवणारे", en: "Calm, steady, loyal, long-term relationships", dosha: "Kapha" }
    }
  }
];
